export const Footer = () =>{
    return(
        <div className="footer">
            <h6>Lisa Lox - Frontend developer {'&'} UX/UI designer. All rights reserved © 2022 -2023</h6>
        </div>
    )
}